import { useState } from 'react';
import Layout from '../../components/feature/Layout';
import LeadsTable from './components/LeadsTable';
import LeadDrawer from './components/LeadDrawer';
import { type Lead, leadScoreConfig } from '../../mocks/leads';

const kpiStats = [
  { label: 'Toplam Lead', value: '621', change: '+11.3%', icon: 'ri-contacts-line', color: '#D4AF37' },
  { label: 'Sıcak Lead', value: '94', change: '+18.2%', icon: 'ri-fire-line', color: '#E57373' },
  { label: 'Dönüşüm Oranı', value: '6.9%', change: '+1.2%', icon: 'ri-percent-line', color: '#7CB342' },
  { label: 'Ort. Yanıt Süresi', value: '2.4sa', change: '-0.8sa', icon: 'ri-time-line', color: '#64B5F6' },
];

export default function LeadManagement() {
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null);

  return (
    <Layout>
      <div className="space-y-5">
        {/* KPI Row */}
        <div className="grid grid-cols-4 gap-4">
          {kpiStats.map(kpi => (
            <div key={kpi.label} className="bg-white rounded-2xl shadow-card p-5 flex items-center gap-4">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0" style={{ backgroundColor: `${kpi.color}15` }}>
                <i className={`${kpi.icon} text-[20px]`} style={{ color: kpi.color }} />
              </div>
              <div className="min-w-0">
                <p className="text-[12px] text-charcoal-300 truncate">{kpi.label}</p>
                <p className="text-[22px] font-bold text-charcoal-600 leading-tight">{kpi.value}</p>
                <p className={`text-[11px] font-medium ${kpi.change.startsWith('+') ? 'text-green-500' : 'text-red-400'}`}>{kpi.change} bu hafta</p>
              </div>
            </div>
          ))}
        </div>

        {/* Score Summary */}
        <div className="bg-white rounded-2xl shadow-card p-5">
          <div className="flex items-center gap-6">
            <div>
              <p className="text-[12px] text-charcoal-300 mb-1">Lead Skoru Dağılımı</p>
            </div>
            <div className="flex-1 flex items-center gap-4">
              {(['hot', 'warm', 'cold'] as const).map(score => {
                const cfg = leadScoreConfig[score];
                const counts = { hot: 94, warm: 287, cold: 240 };
                const total = 621;
                const pct = Math.round((counts[score] / total) * 100);
                return (
                  <div key={score} className="flex items-center gap-2.5">
                    <div className="flex-1 min-w-[120px]">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-[12px] font-medium" style={{ color: cfg.color }}>{cfg.label}</span>
                        <span className="text-[12px] font-bold text-charcoal-600">{counts[score]}</span>
                      </div>
                      <div className="h-2 bg-charcoal-100 rounded-full">
                        <div className="h-2 rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: cfg.color }} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Table + Filters */}
        <LeadsTable onSelectLead={setSelectedLead} />
      </div>

      {/* Lead Detail Drawer */}
      <LeadDrawer lead={selectedLead} onClose={() => setSelectedLead(null)} />
    </Layout>
  );
}
